import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconChevronRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconChevronRight"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M18.998 12.004a2 2 0 0 1-.586 1.416l-9.993 10A2.001 2.001 0 0 1 5 22.003c0-.531.211-1.04.587-1.416l8.574-8.581-8.574-8.58A2.006 2.006 0 0 1 7.005.003c.532 0 1.041.212 1.417.588l9.993 10A2 2 0 0 1 19 12.007" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconChevronRight);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
